@import "../../variables.scss";

.profileBoxWrapper {
  display: flex;
  flex-direction: row;
  @media (max-width: $size-md) {
    flex-direction: column;
  }
}

.downloadContainer {
   display: flex;
   width: 100%;
   padding: 28px;
             flex-direction: row;
             background-color: white;
             justify-content: space-between;

                @media (max-width: $size-md) {
                   flex-direction: column;
    }
}

.imageCircle {

    min-width: 160px;
    width: 160px;
    height: 160px;
    margin-right: 20px;
    border: 6px solid #0054a6;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: $size-md) {
      margin-bottom: 10px;
    }
}

.profile {
  &__admin {
    background: linear-gradient(180deg, #002046 0%, #024798 100%);
    border-radius: 4px;
    padding: 28px;
    color: white;
    display: flex;
    flex-direction: column;
    width: 261px;
    
    @media (max-width: $size-md) {
      margin-right: 0!important;
      width: 100%;
    }

      &_downloadtitle {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin: 0;
      @media (max-width: $size-lg) {
        font-size: 18px;
      }
    }

    &_title {
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin: 12px 0;
      @media (max-width: $size-lg) {
        font-size: 18px;
      }
    }
    &_description {
      margin-bottom: 12px;
      font-size: 16px;
      @media (max-width: $size-md) {
        font-size: 14px;
        line-height: 14px;
      }
    }
    &_button {
      height: 40px;
      width: 160px;
      margin-top: auto;
      font-weight: bold;
      background-color: #ffffff;
      border-color: #ffffff; 
      @media (max-width: $size-sm) {
        margin-top: 1rem;
        width: 100%;
      }
      :hover {
        background-color: #2196f3;
        border-color: #2196f3; 
      }
    }
  }

  &__candidate {
    padding: 20px;
    width: 32%;
    margin-bottom: 0.9rem;
    border: 1px solid #E2E8F0;
    gap: 20px;
    &:not(:last-child) {
      margin-right: 0.9rem;
    }
    @media (max-width: $size-md) {
      margin-right: 0!important;
      width: 100%;
    }

    &_container {
      gap: 12px;
    }

    &_title {
      font-size: 17px;
      line-height: 22px;
    }

    &_icon {
      margin: 12px 0;
    }

    &_button {
      @media (max-width: $size-sm) {
        margin-top: 1rem;
        width: 100%;
      }
    }
  }

  &__job {
    &_container {
      gap: 12px;
    }

    &_title {
      font-size: 17px;
      line-height: 22px;
    }

    &_icon {
      margin: 12px 0;
    }

    &_button {
      @media (max-width: $size-sm) {
        margin-top: 1rem;
        width: 100%;
      }
    }
  }
}